import {CuppaTooltip} from "../../../cuppa/components/cuppa.tooltip";

export const TooltipPosition = CuppaTooltip.POSITION;
export const TooltipArrow = CuppaTooltip.ARROW;
export function Tooltip(
{
	text = '',
	style = null,
	target = '',
	posX = TooltipPosition.CENTER,
	posY = TooltipPosition.BOTTOM,
	arrow = TooltipArrow.UP,
	styleArrow ="",
	forceShow = false,
	className = '',
}){
	return(
		<cuppa-tooltip
			class={className}
			target={target}
			text={text}
			style={{...{fontSize:12, fontWeight:'normal'}, ...style}}
			pos-x={posX}
			pos-y={posY}
			arrow={arrow}
			style-arrow={styleArrow}
			force-show={forceShow}
			theme={'dark'}
		/>
	)
}
